import type { JobPositionEntity } from "@/app/_types/JobPostings";

export const REMOTE_LOCATION = "Remote";

type JobWithLocations = Pick<JobPositionEntity, "locationName" | "locationNames" | "workplaceType"> & {
  isRemote?: boolean;
};

export function isJobRemote(job: JobWithLocations) {
  return (
    Boolean(job.isRemote) ||
    job.workplaceType?.toLowerCase() === "remote" ||
    job.locationNames?.includes(REMOTE_LOCATION) === true
  );
}

export function getJobNonRemoteLocationNames(job: JobWithLocations) {
  const locationNames = job.locationNames?.filter(location => location !== REMOTE_LOCATION);
  if (locationNames?.length) {
    return locationNames;
  }
  if (job.locationName && job.locationName !== REMOTE_LOCATION) {
    return [job.locationName];
  }
  return [];
}

export function formatJobDisplayLocations(job: JobWithLocations, remoteLabel: string) {
  const nonRemoteLocations = getJobNonRemoteLocationNames(job).sort((a, b) => a.localeCompare(b));
  return isJobRemote(job) ? [remoteLabel, ...nonRemoteLocations] : nonRemoteLocations;
}

export function getJobLocationDisplayParts(job: JobWithLocations, remoteLabel: string, maxVisible = Infinity) {
  const allLocations = formatJobDisplayLocations(job, remoteLabel);
  const visibleCount = Number.isFinite(maxVisible) ? maxVisible : allLocations.length;

  return {
    shownLocations: allLocations.slice(0, visibleCount),
    remainingLocations: allLocations.slice(visibleCount),
  };
}
